// Declare the global values used in this Component
declare var angular: angular.IAngularStatic;

import { Component } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';

import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'cts-bulk-upload-complete-dialog',
    template: require('./cts-bulk-upload-complete-dialog.component.html'),
})
export class CtsBulkUploadCompleteDialog {

    constructor(
        public dialogRef: MatDialogRef<CtsBulkUploadCompleteDialog>,
    ) {}

}

angular.module("comcast.directives").directive(
    'ctsBulkUploadCompleteDialog',
    downgradeComponent(
        // The inputs and outputs here must match the relevant names of the properties on the
        // "downgraded" component
        {component: CtsBulkUploadCompleteDialog, inputs: [], outputs: []}));
